export const PRODUCT_TYPES = {
  express: 'express',
  premium: 'premium',
  port: 'port',
  standard: 'standard',
};

export const SERVICE_TYPE_SPACE = '2';
